'use strict';

var _ = require('lodash');
var SystemStatusInterfaceStatusFilterByEventDirectionsFactory = function SystemStatusInterfaceStatusFilterByEventDirectionsFactory(DataFilter, currentStateCriteriaService) {
  function SystemStatusInterfaceStatusFilterByEventDirections() {
    DataFilter.call(this, ['system-status-interface-status-mode'], 'system-status-interface-status', 2);
  }
  SystemStatusInterfaceStatusFilterByEventDirections.constructor = SystemStatusInterfaceStatusFilterByEventDirections;
  SystemStatusInterfaceStatusFilterByEventDirections.prototype = Object.create(DataFilter.prototype);
  function createFilters(rules) {
    var allOptions = ['Input', 'Output'];
    return _.reduce(rules, function (result, rule) {
      if (rule.field === 'eventDirection') {
        if (rule.operator === '=') {
          result = _.union(result, _.intersection(rule.leftOperand, allOptions));
        } else {
          result = _.union(result, _.difference(allOptions, rule.leftOperand));
        }
      }
      return result;
    }, []);
  }
  SystemStatusInterfaceStatusFilterByEventDirections.prototype.filter = function (data) {
    var searchCriteria = currentStateCriteriaService.getSearchCriteria();
    var filter = createFilters(searchCriteria.rules);
    if (!_.size(filter)) {
      return data;
    }
    return DataFilter.prototype.filter(data, filter, 'direction');
  };
  return SystemStatusInterfaceStatusFilterByEventDirections;
};
SystemStatusInterfaceStatusFilterByEventDirectionsFactory.$inject = ['DataFilterFactory', 'CurrentStateCriteriaService'];
module.exports = SystemStatusInterfaceStatusFilterByEventDirectionsFactory;